import Date from './date';
import Letter from './letter';
import Image from './image';

export default { Date, Letter, Image };
